// Recovered compiled webpack factory 20370. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { r: () => i });
  var n = r(49636),
    a = r(21010);
  let o = null;
  function i(e) {
    let t = "unhandledrejection";
    ((0, a.s5)(t, e), (0, a.AS)(t, s));
  }
  function s() {
    ((o = n.O.onunhandledrejection),
      (n.O.onunhandledrejection = function (e) {
        return ((0, a.aj)("unhandledrejection", e), !o || o.apply(this, arguments));
      }),
      (n.O.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0));
  }
}
